import React from 'react'
import loadable from '@loadable/component'
import RecommendationCardSkeleton from '@usap/widgets/src/components/Skeletons/Recommendation.skeleton'

const RecommendationViewCardLoadable = loadable(() => {
    return import('../RecommendationWidgets/Recommendations/RecommendationViewCard');
}, {
    fallback: <RecommendationCardSkeleton />
});

export default RecommendationViewCardLoadable